import axios from 'axios'
import { areaUrl, getHeader } from '@/config'

const state = {
  areaList: []
}

const mutations = {
  SET_AREA_LIST (state, obj) {
    state.areaList = obj
  }
}

const actions = {
  getAreaList: ({ commit }) => {
    axios.get(areaUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_AREA_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
